import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SingleFilterContainer } from "~/components/Filters/SingleFilters/SingleFilterContainer";
import { mapOptionToUploaderFilter, mapUploaderFilterToOption, UploaderFilter } from "~/components/Filters/UploaderFilter/UploaderFilter";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { clearUploadersFilterValuesAction, setUploadersFilterValuesAction } from "~/store/filters/actions";
import { hasUploadersFilterValuesSelector, selectedUploadersFilterSelector } from "~/store/filters/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const SingleUploaderFilter = (param)=>{
    let { uploaders, onApplyClick } = param;
    const dispatch = useDispatch();
    const hasValues = useAirSelector(hasUploadersFilterValuesSelector);
    const selectedUploaders = useSelector(selectedUploadersFilterSelector);
    const { searchImprovements } = useTemporaryFeatureFlags();
    const clearValues = useCallback(()=>{
        dispatch(clearUploadersFilterValuesAction());
    }, [
        dispatch
    ]);
    const uploadersOptions = useMemo(()=>uploaders.map((u)=>mapUploaderFilterToOption(u)), [
        uploaders
    ]);
    const selectedOptions = useMemo(()=>selectedUploaders.map((u)=>mapUploaderFilterToOption(u)), [
        selectedUploaders
    ]);
    const onUploaderSelectionChange = useCallback((uploaders)=>{
        dispatch(setUploadersFilterValuesAction({
            uploaders: uploaders.map((u)=>mapOptionToUploaderFilter(u))
        }));
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        onApplyClick,
        searchImprovements
    ]);
    return /*#__PURE__*/ _jsx(SingleFilterContainer, {
        hasValues: hasValues,
        currentFilter: "source",
        onClearClick: clearValues,
        onApplyClick: onApplyClick,
        children: /*#__PURE__*/ _jsx(UploaderFilter, {
            onUploaderSelectionChange: onUploaderSelectionChange,
            uploadersOptions: uploadersOptions,
            selectedOptions: selectedOptions
        })
    });
};
